module.exports = __webpack_public_path__ + "static/media/work.4b9a0a2f.jpg";